import React from 'react';
import { cn } from '../../lib/cn';

const VARIANTS = {
  default: { wrap: 'bg-slate-50 text-slate-700 border-slate-200', dot: 'bg-slate-400' },
  brand:   { wrap: 'bg-brand-50 text-brand-700 border-brand-200', dot: 'bg-brand-500' },
  success: { wrap: 'bg-emerald-50 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500' },
  warning: { wrap: 'bg-amber-50 text-amber-700 border-amber-200', dot: 'bg-amber-500' },
  danger:  { wrap: 'bg-rose-50 text-rose-700 border-rose-200', dot: 'bg-rose-500' },
  info:    { wrap: 'bg-sky-50 text-sky-700 border-sky-200', dot: 'bg-sky-500' },
  outline: { wrap: 'bg-white text-slate-600 border-slate-200', dot: 'bg-slate-400' }
};

const SIZES = {
  sm: 'h-5 px-1.5 text-[10.5px] gap-1',
  md: 'h-6 px-2 text-[11.5px] gap-1.5'
};

export default function Badge({
  variant = 'default',
  size = 'sm',
  dot = false,
  className,
  children,
  ...rest
}) {
  const v = VARIANTS[variant] || VARIANTS.default;
  return (
    <span
      className={cn(
        'inline-flex items-center font-semibold rounded-full border tracking-wide',
        v.wrap,
        SIZES[size],
        className
      )}
      {...rest}
    >
      {dot && <span className={cn('h-1.5 w-1.5 rounded-full', v.dot)} />}
      {children}
    </span>
  );
}
